/* tslint:disable */
/* eslint-disable */
import type { PaxCheckPaxSession } from './PaxCheckPaxSession';
import {
    PaxCheckPaxSessionFromJSON,
    PaxCheckPaxSessionToJSON,
} from './PaxCheckPaxSession';

export interface PaxCheckApplyManualDocumentResult {
    successfullyVerified: boolean;
    updatedPaxSession: PaxCheckPaxSession;
}

export function instanceOfPaxCheckApplyManualDocumentResult(value: object): value is PaxCheckApplyManualDocumentResult {
    if (!('successfullyVerified' in value) || value['successfullyVerified'] === undefined) return false;
    if (!('updatedPaxSession' in value) || value['updatedPaxSession'] === undefined) return false;
    return true;
}

export function PaxCheckApplyManualDocumentResultFromJSON(json: any): PaxCheckApplyManualDocumentResult {
    return PaxCheckApplyManualDocumentResultFromJSONTyped(json, false);
}

export function PaxCheckApplyManualDocumentResultFromJSONTyped(json: any, _ignoreDiscriminator: boolean): PaxCheckApplyManualDocumentResult {
    if (json == null) return json;
    return {
        successfullyVerified: json['successfully_verified'],
        updatedPaxSession: PaxCheckPaxSessionFromJSON(json['updated_pax_session']),
    };
}

export function PaxCheckApplyManualDocumentResultToJSON(value?: PaxCheckApplyManualDocumentResult | null): any {
    if (value == null) return value;
    return {
        successfully_verified: value.successfullyVerified,
        updated_pax_session: PaxCheckPaxSessionToJSON(value.updatedPaxSession),
    };
}
